module.exports = __webpack_public_path__ + "static/media/prof-app.6c8ab60b.svg";